export default __webpack_public_path__ + "static/Customize_Audience-76fe06a981f37dc86723ce417a64c56d.svg";